import React, { useState, useEffect } from 'react'
import './styles.scss'
import coupons from 'data/shop/coupons'
import Button from 'components/Button'
import { useCartContext } from 'context/shop/CartProvider'
import { numberWithCommas } from 'utils/priceConvert'
import { randomShippingFee } from 'utils/helperText'
import ModalSuccess from 'components/Modal'

const FormDiscount = ({ validForm, formDataValue, setShowErrors }) => {
  const [discount, setDiscount] = useState('0.00')
  const [couponCode, setCouponCode] = useState('')
  const [couponError, setCouponError] = useState('')
  const [totalPrice, setTotalPrice] = useState(0)
  const { cartItems, removeAllItems } = useCartContext()
  const [shipFee, setShippingFee] = useState(randomShippingFee(100, 500))

  const [showModal, setShowModal] = useState(false)
  const maxLength = 15

  const handleCompletedOrder = () => {
    if (validForm) {
      console.log('Form data submitted', formDataValue)
      setShowModal(true)
      setDiscount(0)
      setShippingFee(0)
      removeAllItems()
      setShowModal(true)
    } else {
      console.log('Form data is not valid')
      setShowErrors(true)
    }
  }

  // Handle total price of the order
  useEffect(() => {
    setTotalPrice(
      cartItems.reduce((total, item) => total + Number(item.quantity) * Number(item.price), 0) +
        Number(shipFee) -
        Number(discount)
    )
  }, [cartItems, discount, shipFee])

  // Handle applying a discount for the order
  const handleCoupon = () => {
    const coupon = Object.values(coupons).find((coupon) => coupon.code === couponCode)
    console.log(couponCode)
    const couponCodeError = couponCode + ' does not exist'
    if (coupon) {
      setDiscount(coupon.discount)
      setCouponError('')
      setCouponError('success')
    } else {
      setCouponError(couponCodeError)
    }
  }

  return (
    <div className="form-checkout-right">
      <div
        className={`modal-overlay ${showModal ? '' : 'hidden'}`}
        onClick={() => setShowModal(false)} // Close the modal when clicking outside
      >
        <div className="modal-content">
          <ModalSuccess>Payment done successfully.</ModalSuccess>
        </div>
      </div>
      <div className="frame-voucher">
        <input
          className="voucher-input"
          placeholder="Discount..."
          value={couponCode}
          onChange={(e) => setCouponCode(e.target.value)}
          maxLength={maxLength}
        />
        <div className="frame-button-apply">
          <Button fontSize="lg" size="min" backgroundColor="apply" onClick={handleCoupon}>
            Apply
          </Button>
        </div>
      </div>
      <div className="frame-error-voucher">
        <p className={`${couponError === 'success' ? 'success' : 'error'}`}>{couponError}</p>
      </div>
      <div className="frame-compute-money">
        <div className="frame-shipping-fee">
          <p>Shipping Fee:</p>
          <p className="number-price">$ {numberWithCommas(shipFee)}</p>
        </div>
        <div className="frame-shipping-voucher">
          <p>Voucher:</p>
          <p className="number-price">$ {numberWithCommas(discount)}</p>
        </div>
        <div className="frame-shipping-total">
          <p>Total:</p>
          <p className="number-total">$ {numberWithCommas(totalPrice)}</p>
        </div>
      </div>
      <div className="button-completed-order">
        <Button
          fontSize="h4"
          size="xxl"
          backgroundColor="custom"
          color="color"
          borderRadius="checkout"
          onClick={handleCompletedOrder}
        >
          COMPLETE ORDER
        </Button>
      </div>
    </div>
  )
}

export default FormDiscount
